import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, FAQ, CTABand, StatRow } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

const faqItems = [
  { q: "¿Qué es un préstamo fix-and-flip?", a: "Es un préstamo a corto plazo para adquirir y renovar una propiedad de inversión con el objetivo de venderla o refinanciarla." },
  { q: "¿Cuánto financian?", a: "Programas comunes cubren hasta ~90% del costo de adquisición y 100% de renovaciones elegibles, con LTV global limitada." },
  { q: "¿Se requiere experiencia?", a: "Sí, muchos programas exigen experiencia previa de flip o construcción; los primerizos pagan términos más conservadores." },
  { q: "¿Qué plazos ofrecen?", a: "Términos de 6 a 24 meses, con opciones de extensión en programas elegibles." },
];

export const Route = createFileRoute("/es/prestamos-fix-and-flip")({
  head: () =>
    buildHead({
      title: "Préstamos Fix & Flip | Renovación y Reventa | Simply Approved",
      description:
        "Préstamos corto plazo para comprar y renovar propiedades de inversión. Hasta 90% adquisición + renovaciones en programas elegibles. Requiere experiencia previa.",
      url: "/es/prestamos-fix-and-flip",
      locale: "es",
      keywords: "préstamos fix and flip, préstamos renovación reventa, financiamiento flip propiedad, préstamos corto plazo inversión",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Fix & Flip", url: "/es/prestamos-fix-and-flip" },
      ],
      service: { name: "Préstamos Fix & Flip" },
      faqs: faqItems,
    }),
  component: FixAndFlipPage,
});

function FixAndFlipPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Fix & Flip" title="Financie la compra y renovación de su próxima propiedad." subtitle="Préstamos de corto plazo para inversionistas que compran, mejoran y venden propiedades." />
      <Section>
        <SectionHeader title="Puntos clave" center />
        <StatRow
          items={[
            { label: "Adquisición", value: "Hasta 90%" },
            { label: "Renovaciones", value: "Hasta 100%" },
            { label: "Plazo", value: "6–24 meses" },
            { label: "Propósito", value: "Inversión" },
            { label: "Experiencia", value: "Requerida" },
            { label: "Pago", value: "Solo intereses" },
          ]}
        />
        <p className="mt-3 text-xs text-muted-foreground">
          Los porcentajes y términos son representativos de programas elegibles. Cada programa
          limita el LTV combinado, requiere presupuesto de renovación y aprobación del prestamista
          mayorista.
        </p>
      </Section>
      <Section>
        <div className="mx-auto max-w-4xl">
          <SectionHeader title="Preguntas frecuentes" center />
          <FAQ items={faqItems} />
        </div>
      </Section>
      <CTABand title="¿Tiene un proyecto fix-and-flip?" body="Envíenos el escenario y le diremos qué programas de renovación encajan." />
    </SiteShell>
  );
}
